"use client";

import * as React from "react";
import { ColumnDef } from "@tanstack/react-table";
import CommonList from "@/components/common/List";
import CommonTableList from "@/components/common/TableList";
import PartnersCreate from "./Create";
import { PartnerData } from "@/interface/entityInterface";
import PartnersDetails from "./PartnersDetails";
import { tableCol } from "@/components/common/columns/columns";
import PartnerEdit from "./Edit";
import { handleRowClick } from "@/utils/functions";

export const columns: ColumnDef<PartnerData>[] = tableCol({
  showActions: true,
  columns: [
    {
      accessorKey: "full_name",
      header: "Full Name",
      cell: ({ row }: any) => (
        <div className="capitalize">
          {row.original.user?.firstname + " " + row.original.user?.lastname}
        </div>
      ),
    },
    {
      accessorKey: "email",
      header: "Email",
      cell: ({ row }: any) => <div>{row.original.user?.email}</div>,
    },
    {
      accessorKey: "percentage_commission",
      header: "Commission (%)",
      cell: ({ row }) => (
        <div className="capitalize">
          {row.getValue("percentage_commission")} %
        </div>
      ),
    },
  ],
  resource: "referral-agents",
  responseMessage: (row: PartnerData) =>
    `${row.user?.firstname + " " + row.user?.lastname} is no longer a partner`,
  EditComponent: PartnerEdit,
});

const PartnersList = () => {
  const [open, setOpen] = React.useState(false);
  const [partner, setPartner] = React.useState<PartnerData | null>(null);

  return (
    <>
      <CommonList>
        <CommonTableList
          filterSearch="email"
          columns={columns}
          create={<PartnersCreate />}
          rowClick={(row: PartnerData) =>
            handleRowClick(row, setPartner, setOpen)
          }
        />
      </CommonList>
      {open && (
        <PartnersDetails open={open} setOpen={setOpen} partner={partner} />
      )}
    </>
  );
};

export default PartnersList;
